const $ = require('jquery');
import run from '../../../utilities/run';
import render from "../../../utilities/render";
// import DetailsBusinessLogic from "detailsBusinessLogic.js"
import DetailsBusinessLogic from './detailsBusinessLogic.js'

// NOTE - choose target (id or unique class) where you want this to
const targetSelector = "#user-details-page-id";

run(targetSelector, (outerEl)=>{
 attachDetailsPage(outerEl);
});

function attachDetailsPage(outerEl){
    const teamMembersDetailsLogic = new DetailsBusinessLogic(outerEl);
    teamMembersDetailsLogic.init();
};



// WEBPACK FOOTER //
// ./src/pages/teamMembers/details/details.js